import { LoggerLevel, LoggerSource } from './LoggerLevel';
import { TLoggerState, TLoggerStateItem } from './Logger.types';

const isDebug = process.env.DEBUG_TOOL === 'true';

const defaultStateItem: TLoggerStateItem = {
    console: isDebug,
    kibana: false
};

export const DefaultState: TLoggerState = {
    levels: Object.values(LoggerLevel).reduce((acc, level) => {
        acc[level] = { ...defaultStateItem };
        return acc;
    }, {} as Record<LoggerLevel, TLoggerStateItem>),

    sources: Object.values(LoggerSource).reduce((acc, source) => {
        acc[source] = { ...defaultStateItem };
        return acc;
    }, {} as Record<LoggerSource, TLoggerStateItem>)
};
